<template>
    <div v-if="links.length > 3">
        <div class="btn-group">
            <template v-for="(link, k) in links" :key="k">
                <div v-if="link.url === null" class="btn btn-light" v-html="link.label" />
                <inertia-link v-else class="btn"
                              :class="link.active ? 'btn-dark' : 'btn-light'"
                              :href="link.url"
                              v-html="link.label" />
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "Pagination",
    props: {
        links: Array,
    },
}
</script>

<style scoped>

</style>
